import React from "react";
import { Table, Typography } from "antd";
import { useIntl } from "react-intl";
import moment from "moment";
import Employee from "../tables/Employee";
import Patient from "../tables/Patient";
import Date from "../tables/Date";
const { Text, Title } = Typography;

const OverlappingEvents = (props) => {
  const { data, forbidden } = props;

  const intl = useIntl();

  const columns = [
    {
      title: intl.formatMessage({
        id: forbidden
          ? "app.scheduling.table.schedulingPatientName"
          : "app.scheduling.table.schedulingEmployeeName",
      }),
      dataIndex: "employee",
      render(text, record) {
        return record.is_day_center ? (
          <Text>
            {intl.formatMessage({
              id: "app.scheduling.day_center",
            })}
          </Text>
        ) : text ? (
          forbidden ? (
            <Patient record={record?.order?.patient} />
          ) : (
            <Employee record={text} />
          )
        ) : null;
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.date",
      }),
      dataIndex: "date",
      render(text, record) {
        return <Date text={text} format={"DD/MM/YYYY"} />;
      },
      width: "100px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.schedulingStartHour",
      }),
      dataIndex: "date",
      render(text) {
        return <Date text={text} format={"HH:mm"} />;
      },
      width: "100px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.schedulingEndHour",
      }),
      dataIndex: "date",
      width: "100px",
      render(text, record) {
        return (
          <Date
            text={moment(text).add(record.duration_minutes, "minutes")}
            format={"HH:mm"}
          />
        );
      },
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.client",
      }),
      ellipsis: true,
      dataIndex: "client_name",
      render(text, record) {
        return <Text>{text}</Text>;
      },
      width: "140px",
    },
  ];
  return (
    <div style={{ width: "800px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "0",
          }}
        >
          {`${intl.formatMessage({
            id: forbidden
              ? "app.scheduling.forbiddenEvents"
              : "app.scheduling.overlappingEvents",
          })}  `}
        </Title>

        <div>
          <Table
            bordered
            dataSource={data}
            columns={columns}
            pagination={false}
            scroll={{
              y: window.innerHeight / 2,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OverlappingEvents;
